export const aircraftSearchBy = [
	{ key: "owner", value: "Owner" },
	{ key: "manager", value: "Manager" },
];

export const aircraftCabin = [
	{ key: "f", value: "First" },
	{ key: "c", value: "Business" },
	{ key: "w", value: "Premium Economy" },
	{ key: "yp", value: "Economy Plus/Comfort" },
	{ key: "y", value: "Economy" },
];

export const aircraftUpdateType = [
	{ key: "new", value: "Additions" },
	{ key: "upd", value: "Updates" },
];

export const forecastTypes = [
	{ key: "hours", value: "Hours" },
	{ key: "cycles", value: "Cycles" },
];

export const showMultipleOperators = [
	{ key: "no", value: "Do not show multiple operators" },
	{ key: "yes", value: "Show multiple operators" },
];

export const aircraftUpdatePeriod = [
	{ key: null, value: "Any" },
	{ key: "8", value: "Last 8 days" },
	{ key: "15", value: "Last 15 days" },
	{ key: "31", value: "Last 31 days" },
	{ key: "90", value: "Last 90 days" },
];

export const powerSource = [
	{ key: "110V", value: "110V" },
	{ key: "115V", value: "115V" },
	{ key: "120V", value: "120V" },
];

export const usbPortType = [
	{ key: "a", value: "A" },
	{ key: "c", value: "C" },
	{ key: "a/c", value: "A/C" },
];
